import { AiProduct } from 'components/goods/ai/AiProduct/AiProduct'
import { useParams, useSearchParams } from 'react-router-dom'
import { parseEnhancementOptions } from 'shared/utils/goods/parseEnhancementOptions'

export const AiGoodsCreate: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const [searchParams] = useSearchParams()

  const enhancementOptions = parseEnhancementOptions(searchParams)

  return (
    <AiProduct
      productId={id as string}
      type='create'
      createData={enhancementOptions}
    />
  )
}
